import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL, trackCheckout } from "../utils/checkout";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const firstCta = document.getElementById("first-cta");
      if (!firstCta) return;
      setVisible(firstCta.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-133" data-mp="2fslabeugqdyf">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-950/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-134" data-mp="2awcvy3o3aosb">
          <a href={CHECKOUT_URL} onClick={trackCheckout} className="animate-shake mx-auto flex min-h-[56px] w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-cta px-4 font-display text-[17px] font-extrabold uppercase tracking-wide text-navy-950 shadow-[0_4px_0_0_#C99A00] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-accent/60" data-id="element-135" data-mp="333b0hd4gz6rl">
            <span data-id="element-136" data-mp="2kdbfb1br2btg">Get the Blueprint · $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-137" data-mp="2kaynzxk3qp3q" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}